import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'styles/QuillEditorOverrides/styles.css';
import 'react-tabs/style/react-tabs.css';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactBreakpoints from 'react-breakpoints';
import { Provider } from 'react-redux';
import { ConnectedRouter, push } from 'connected-react-router';
import axios from 'axios';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { debounce } from 'lodash';
import { clearAuthToken } from 'services/auth/duck';
import { fetchCurrentUser } from 'services/users/duck';
import { increaseActiveRequestCount, decreaseActiveRequestCount } from 'services/exports/duck';
import 'assets/fonts/goodwayml/index.font';
import 'semantic-ui-css/semantic.css';
import { storeFactory, history } from './store';
import ErrorBoundary from './ErrorBoundary';

import App from './App';

// Carry over from create-react-app
import { unregister } from './registerServiceWorker';

const api = axios.create();
const store = storeFactory({}, { api });
store.getHistory = () => history;

/**
 * BEGIN Registration of Axios API interceptors
 *   - Covers auto redirection on 401 error code
 *   - Monitors global active http calls for top-level progress bar
 */
let requestCount = 0;

api.interceptors.response.use(value => value, (error) => {
    if (error.response && error.response.status === 401) {
        const state = store.getState();
        const { pathname, search } = state.router.location;
        let fromUrl = pathname;
        if (search) {
            fromUrl += `${search}`;
        }

        if (pathname !== '/login') {
            store.dispatch(clearAuthToken({ hideSuccess: true }));
            store.dispatch(push(`/login?from=${encodeURIComponent(fromUrl)}`));
        }
    }
    return Promise.reject(error);
});

api.interceptors.request.use((request) => {
    if (requestCount === 0) {
        store.dispatch(showLoading());
    }
    requestCount += 1;
    store.dispatch(increaseActiveRequestCount());
    return request;
});

api.interceptors.response.use((response) => {
    requestCount = requestCount < 0 ? 0 : requestCount - 1;

    if (requestCount === 0) {
        store.dispatch(hideLoading());
    }

    setTimeout(() => store.dispatch(decreaseActiveRequestCount()), 100);
    return response;
}, (error) => {
    requestCount = requestCount < 0 ? 0 : requestCount - 1;

    if (requestCount === 0) {
        store.dispatch(hideLoading());
    }

    setTimeout(() => store.dispatch(decreaseActiveRequestCount()), 100);
    return Promise.reject(error);
});

// Capture x-gg-refresh-user command to refresh user
const triggerUserRefresh = debounce(() => {
    store.dispatch(fetchCurrentUser({ disableNavigation: true }));
}, 15000, { leading: true, trailing: false });

api.interceptors.response.use((response) => {
    if (response.headers['x-gg-refresh-user'] === '1') {
        triggerUserRefresh();
    }

    return response;
}, err => Promise.reject(err));
/**
 * END Axios interceptors
 */

const breakpoints = store.getState().theme.breakpoints;

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <ReactBreakpoints breakpoints={breakpoints} debounceResize={true}>
                <ErrorBoundary>
                    <App />
                </ErrorBoundary>
            </ReactBreakpoints>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);

// Disabling for now because of the quick iteration
unregister();



// WEBPACK FOOTER //
// ./src/index.js